import theme from '../theme'
import { makeStyles } from '@material-ui/core'
import { styled, StyledComponentProps } from '@material-ui/core/styles'
import { ComponentType, ElementType } from 'react'

export const customClasses = makeStyles({
  helperText: {
    textAlign: 'right',
    margin: '1px 0 0 0',
  },
})

export const successStylesComponent: (
  component: ElementType<any>
) => ComponentType<
  Pick<any, string | number | symbol> &
    StyledComponentProps<'root'> & { className?: string }
> = (component) => {
  return styled(component)({
    color: theme.palette.success.main,
  })
}

export const styleOverride = makeStyles({
  /* Styles applied to the root element. */
  root: {
    '& .MuiInput-colorSecondary': {
      '&$underline:after': {
        borderBottomColor: theme.palette.secondary.main,
      },
    },
    /* Styles applied to the root element if `disableUnderline={false}`. */
    '& .MuiInput-underline': {
      '&:after': {
        borderBottom: `2px solid ${theme.palette.primary.main}`,
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut,
        }),
        pointerEvents: 'none', // Transparent to the hover style.
      },
      '&$focused:after': {
        transform: 'scaleX(1)',
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)', // error is always underlined in red
      },
      '&:hover:not($disabled):before': {
        borderBottom: `2px solid ${theme.palette.text.primary}`,
      },
      '&$disabled:before': {
        borderBottomStyle: 'dotted',
      },
    },
    '& .MuiOutlinedInput-root': {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      '&:hover $notchedOutline': {
        borderColor: theme.palette.text.primary,
      },
      '&$focused $notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: 2,
      },
      '&$error $notchedOutline': {
        borderColor: theme.palette.error.main,
      },
      '&$disabled $notchedOutline': {
        borderColor: theme.palette.action.disabled,
      },
    },
    /* Styles applied to the root element if the color is secondary. */
    '& .MuiOutlinedInput-colorSecondary': {
      '&$focused $notchedOutline': {
        borderColor: theme.palette.secondary.main,
      },
    },
    /* Styles applied to the `input` element. */
    '& .MuiOutlinedInput-input': {
      padding: '18.5px 14px',
      '&:-webkit-autofill': {
        WebkitBoxShadow:
          theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
        caretColor: theme.palette.type === 'light' ? null : '#fff',
        borderRadius: 'inherit',
      },
    },
    '& .MuiFilledInput-root': {
      position: 'relative',
      borderTopLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut,
      }),
    },
    /* Styles applied to the root element if color secondary. */
    '& .MuiFilledInput-colorSecondary': {
      '&$underline:after': {
        borderBottomColor: theme.palette.secondary.main,
      },
    },
    /* Styles applied to the root element if `disableUnderline={false}`. */
    '& .MuiFilledInput-underline': {
      '&:after': {
        borderBottom: `2px solid ${theme.palette.primary.main}`,
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut,
        }),
        pointerEvents: 'none', // Transparent to the hover style.
      },
      '&$focused:after': {
        transform: 'scaleX(1)',
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)', // error is always underlined in red
      },
      '&:hover:not($disabled):before': {
        borderBottom: `1px solid ${theme.palette.text.primary}`,
      },
    },
    '& .MuiInputBase-root': {
      // Mimics the default input display property used by browsers for an input.
      ...theme.typography.body1,
      color: theme.palette.text.primary,
      lineHeight: '1.1876em', // Reset (19px), match the native input line-height
      boxSizing: 'border-box', // Prevent padding issue with fullWidth.
      position: 'relative',
      cursor: 'text',
      display: 'inline-flex',
      alignItems: 'center',
      '&$disabled': {
        color: theme.palette.text.disabled,
        cursor: 'default',
      },
    },
    // '& .Mui-checked': {},
    // '& .Mui-disabled': {},
    // '& .Mui-error': {},
    // '& .Mui-focused': {},
    // '& .Mui-focusVisible': {},
    // '& .Mui-required': {},
    // '& .Mui-expanded': {},
    // '& .Mui-selected': {},
  },
})
